import { ChangeEvent, InvalidEvent, useEffect } from "react";
import { Col, FormFeedback, FormGroup, Input, Label, Row } from "reactstrap";
import useValueList from "../../../hook/useValueList";
import { ContainerLayoutProps } from "../../../types/common";
import { Action } from "../../../types/reducer-action";
import { DataEntryEvent, FormErrorAction, FormUpdateAction } from "../../common/data-entry-reducer";
import TextInput from "../../common/text-input";
import { usePositionTitleDispatch, usePositionTitleState } from "./position-manager-context";

const PositionInfoPanel = (props: ContainerLayoutProps) => {
  const { wide, autoFocus } = props;

  const colWidth = wide ? 6 : 12;

  const dispatch = usePositionTitleDispatch();

  const { form, errors } = usePositionTitleState();

  const [categoryTypes] = useValueList('ORG_CATEGORY_TYPE', true);

  useEffect(() => {
    // set init state for new record
    if (!form.categoryId && categoryTypes?.length > 0) {
      dispatch(new Action(DataEntryEvent.UpdateForm, {
        categoryId: categoryTypes[0].id,
        status: true
      }));
    }
  }, [categoryTypes, form.categoryId, dispatch])

  const handleChange = (event: ChangeEvent<HTMLInputElement>) =>
    dispatch(new FormUpdateAction(event));

  const handleInvalid = (event: InvalidEvent<HTMLInputElement>) => {
    event.preventDefault();

    const { name, validity } = event.target;

    if (name === 'positionName' && validity.patternMismatch) {
      dispatch(new Action(DataEntryEvent.AddErrors,
        { [name]: "Only the following special characters are allowed: & ( ) / _ - ' . , : ;" }
      ));
    } else {
      dispatch(new FormErrorAction(event));
    }
  };

  return (
    <section>
      <Row className="gx-5">
        <Col md={colWidth}>
          <FormGroup row>
            <Label for="position_name" sm={4}>Position/Role Title (Required):</Label>
            <Col sm={8}>
              <TextInput 
                trim 
                id="position_name" 
                name="positionName"
                placeholder="Enter a postion/role title"
                value={form?.positionName ?? ''} 
                onChange={handleChange}
                invalid={!!errors.positionName} 
                onInvalid={handleInvalid}
                pattern="^[A-Za-z0-9 \-\/\(\)\.,:;'&_]*$"
                minLength={2} 
                maxLength={200}
                autoFocus={autoFocus}
                required />
              <FormFeedback invalid={errors.positionName} className="mt-0 mb-2">
                {errors.positionName}
              </FormFeedback>
            </Col>
          </FormGroup>
        </Col>
        <Col md={colWidth}>
          <FormGroup row>
            <Label for="category_id" id="category_id_label" sm={4}>Organization Type:</Label>
            <Col sm={8}>
              <Input type="select" id="category_id" name="categoryId" aria-labelledby="category_id_label"
                value={form.categoryId ?? ''}
                onChange={handleChange}>
                {categoryTypes.map(item =>
                  <option key={item.id} value={item.id}>
                    {item.label}
                  </option>
                )}
              </Input>
            </Col>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <FormGroup check>
            <Input type="checkbox" id="status" name="status"
              checked={!!form.status} onChange={() => dispatch(new Action(DataEntryEvent.UpdateForm, { status: !form.status }))} />
            {' '}
            <Label for="status" check>Active?</Label>
          </FormGroup>
        </Col>
      </Row>

    </section>
  )
}

export default PositionInfoPanel;
